var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title:
            _vm.isChoose ||
            _vm.isCopy ||
            _vm.isDisabled ||
            _vm.$route.params.id == 0
              ? "添加商品"
              : "编辑商品",
          backUrl: "/marketing/pointsMall/productManage",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            },
            _vm._l(_vm.headTab, function (item, index) {
              return _c("el-tab-pane", {
                key: index,
                attrs: { label: item.tit, name: item.name },
              })
            }),
            1
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.fullscreenLoading,
                  expression: "fullscreenLoading",
                },
              ],
              ref: "formValidate",
              staticClass: "formValidate form-boder-padding",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "108px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "1",
                      expression: "currentTab === '1'",
                    },
                  ],
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称：", prop: "name" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              maxlength: "100",
                              "show-word-limit": "",
                              placeholder: "请输入商品名称",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品分类：", prop: "cateIds" } },
                        [
                          _c("el-cascader", {
                            ref: "cascader",
                            staticClass: "from-ipt-width",
                            attrs: {
                              clearable: "",
                              options: _vm.merPlatProductClassify,
                              props: _vm.categoryProps,
                            },
                            model: {
                              value: _vm.formValidate.cateIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "cateIds", $$v)
                              },
                              expression: "formValidate.cateIds",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单位：", prop: "unitName" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              placeholder: "请输入单位",
                              disabled: _vm.isDisabled,
                              maxlength: "16",
                            },
                            model: {
                              value: _vm.formValidate.unitName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "unitName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.unitName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "归属应用标识：",
                            prop: "appIdentifierList",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width",
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.formValidate.appIdentifierList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formValidate,
                                    "appIdentifierList",
                                    $$v
                                  )
                                },
                                expression: "formValidate.appIdentifierList",
                              },
                            },
                            _vm._l(
                              _vm.appIdentifierList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.name,
                                    value: item.appIdentifier,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v("注：若不选择，则所有应用都会显示该商品"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "用户来源：",
                            prop: "userSourceList",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width",
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.formValidate.userSourceList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formValidate,
                                    "userSourceList",
                                    $$v
                                  )
                                },
                                expression: "formValidate.userSourceList",
                              },
                            },
                            _vm._l(_vm.userSourceList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v("注：若不选择，则所有来源都会显示该商品"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品封面图：", prop: "image" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox acea-row",
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTap(false)
                                },
                              },
                            },
                            [
                              _vm.formValidate.image
                                ? _c("div", { staticClass: "pictrue" }, [
                                    _c("img", {
                                      attrs: { src: _vm.formValidate.image },
                                    }),
                                  ])
                                : _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                                  ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isDisabled,
                                  expression: "!isDisabled",
                                },
                              ],
                              staticClass: "from-tips",
                            },
                            [_vm._v("建议尺寸：800*800px，上传小于500kb的图片")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商品轮播图：",
                            prop: "sliderImages",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "acea-row" },
                            [
                              _vm._l(
                                _vm.formValidate.sliderImages,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "pictrue",
                                      attrs: { draggable: "true" },
                                      on: {
                                        dragstart: function ($event) {
                                          return _vm.handleDragStart(
                                            $event,
                                            item
                                          )
                                        },
                                        dragover: function ($event) {
                                          $event.preventDefault()
                                          return _vm.handleDragOver(
                                            $event,
                                            item
                                          )
                                        },
                                        dragenter: function ($event) {
                                          return _vm.handleDragEnter(
                                            $event,
                                            item
                                          )
                                        },
                                        dragend: function ($event) {
                                          return _vm.handleDragEnd($event, item)
                                        },
                                      },
                                    },
                                    [
                                      _c("img", { attrs: { src: item } }),
                                      _c("i", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.isDisabled,
                                            expression: "!isDisabled",
                                          },
                                        ],
                                        staticClass: "el-icon-error btndel",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRemove(index)
                                          },
                                        },
                                      }),
                                    ]
                                  )
                                }
                              ),
                              _vm.formValidate.sliderImages.length < 10 &&
                              !_vm.isDisabled
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "upLoadPicBox",
                                      on: {
                                        click: function ($event) {
                                          return _vm.modalPicTap(
                                            true,
                                            "sliderImages"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "upLoad" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-camera cameraIconfont",
                                        }),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "建议尺寸：800*800px，上传小于500kb的图片；最多可上传10张图片，拖动可调整顺序"
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "运费模板：", prop: "tempId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width mr20",
                              attrs: {
                                placeholder: "请选择",
                                disabled: _vm.isDisabled,
                              },
                              model: {
                                value: _vm.formValidate.tempId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formValidate, "tempId", $$v)
                                },
                                expression: "formValidate.tempId",
                              },
                            },
                            _vm._l(_vm.shippingTemplates, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: "(" + item.id + ")" + item.name,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品关键字：" } },
                        [
                          _c("keyword", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              labelarr: _vm.labelarr,
                              isDisabled: _vm.isDisabled,
                            },
                            on: { getLabelarr: _vm.getLabelarr },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v("用户可以根据关键字进行商品搜索"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "主图视频：", prop: "video_link" } },
                        [
                          _c(
                            "div",
                            { staticClass: "acea-row" },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    size: "small",
                                    placeholder: "请输入MP4格式的视频链接",
                                  },
                                  model: {
                                    value: _vm.videoLink,
                                    callback: function ($$v) {
                                      _vm.videoLink = $$v
                                    },
                                    expression: "videoLink",
                                  },
                                },
                                [
                                  _c("input", {
                                    ref: "refid",
                                    staticStyle: { display: "none" },
                                    attrs: { type: "file" },
                                  }),
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "upload-demo",
                                      attrs: {
                                        slot: "append",
                                        action: "",
                                        "http-request": _vm.handleUploadForm,
                                        "before-upload": _vm.beforeAvatarUpload,
                                        headers: _vm.myHeaders,
                                        "show-file-list": false,
                                        disabled: _vm.isDisabled,
                                        multiple: "",
                                      },
                                      slot: "append",
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled: _vm.isDisabled,
                                            size: "small",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.videoLink
                                                  ? "确认添加"
                                                  : "上传视频"
                                              )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v("请上传小于20M的视频"),
                          ]),
                          _vm.videoLink
                            ? _c("div", { staticClass: "iview-video-style" }, [
                                _c(
                                  "video",
                                  {
                                    staticClass: "from-ipt-width",
                                    staticStyle: {
                                      height: "100% !important",
                                      "border-radius": "10px",
                                    },
                                    attrs: {
                                      src: _vm.videoLink,
                                      controls: "controls",
                                    },
                                  },
                                  [_vm._v(" 您的浏览器不支持 video 标签。 ")]
                                ),
                                _c("div", { staticClass: "mark" }),
                                _c("i", {
                                  staticClass: "el-icon-delete iconv",
                                  on: { click: _vm.delVideo },
                                }),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品简介：", prop: "intro" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              type: "textarea",
                              maxlength: "100",
                              rows: 3,
                              placeholder:
                                "请输入商品简介，最多可输入250字（商品简介用于通过公众号分享商品详情，会展示此简介信息）",
                              disabled: _vm.isDisabled,
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.formValidate.intro,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "intro",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.intro",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v("通过公众号分享商品详情，会展示此简介信息"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "虚拟库存：", prop: "virtualStock" },
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 0,
                              max: 99999,
                              step: 1,
                              "step-strictly": "",
                            },
                            model: {
                              value: _vm.formValidate.virtualStock,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "virtualStock",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.virtualStock",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "兑换热度：",
                            prop: "virtualExchangeNum",
                          },
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 1,
                              max: 99.9,
                              step: 0.1,
                              "step-strictly": "",
                            },
                            model: {
                              value: _vm.formValidate.virtualExchangeNum,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "virtualExchangeNum",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.virtualExchangeNum",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "热销榜单位置：",
                            prop: "platformHotSell",
                          },
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 1,
                              max: 99,
                              step: 1,
                              "step-strictly": "",
                            },
                            model: {
                              value: _vm.formValidate.platformHotSell,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "platformHotSell",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.platformHotSell",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "兑换数量限制：",
                            prop: "exchangeNum",
                          },
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 0,
                              max: 9999,
                              step: 1,
                              "step-strictly": "",
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.formValidate.exchangeNum,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "exchangeNum",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.exchangeNum",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "用户可以兑换总数量限制，支持输入0～9999整数，填0代表不限制"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "红包抵扣：", prop: "redPacket" } },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 0,
                              max: 999999,
                              step: 0.01,
                              precision: 2,
                              "step-strictly": "",
                              placeholder: "请输入红包抵扣金额",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.redPacket,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "redPacket",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.redPacket",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "设置商品可使用红包抵扣的金额，0表示不可使用红包抵扣(单位:元)"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "上架状态：", required: "" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": true,
                              "inactive-value": false,
                              "active-text": "上架",
                              "inactive-text": "下架",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.isShow,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "isShow",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.isShow",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "热门推荐：", required: "" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-text": "是",
                              "inactive-text": "否",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.isHot,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "isHot",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.isHot",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "排序：" } },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 1,
                              max: 999999,
                              placeholder: "请输入排序",
                              disabled: _vm.isDisabled,
                              step: 1,
                              "step-strictly": "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                return _vm.proving1($event)
                              },
                            },
                            model: {
                              value: _vm.formValidate.sort,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "sort",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.sort",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v("请输入0～999999的数字，数字越大越靠前"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "售后地址：",
                            prop: "merchantAddressId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width",
                              attrs: {
                                filterable: "",
                                disabled: _vm.isDisabled,
                              },
                              model: {
                                value: _vm.formValidate.merchantAddressId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formValidate,
                                    "merchantAddressId",
                                    $$v
                                  )
                                },
                                expression: "formValidate.merchantAddressId",
                              },
                            },
                            _vm._l(_vm.merchantAddressList, function (item) {
                              return _c(
                                "el-option",
                                {
                                  key: item.id,
                                  attrs: { label: item.label, value: item.id },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "from-ipt-width line1",
                                      attrs: { title: item.label },
                                    },
                                    [_vm._v(_vm._s(item.label))]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isShowAttr
                ? _c("creatAttr", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.currentTab === "2",
                        expression: "currentTab === '2'",
                      },
                    ],
                    attrs: {
                      oneFormBatch: _vm.oneFormBatch,
                      isDisabled: _vm.isDisabled,
                      formThead: _vm.formThead,
                      manyTabDate: _vm.manyTabDate,
                      ManyAttrValue: _vm.ManyAttrValue,
                      OneattrValue: _vm.OneattrValue,
                      manyTabTit: _vm.manyTabTit,
                    },
                    on: {
                      handleBatchDel: _vm.handleBatchDel,
                      changeIsEditVal: _vm.changeIsEditVal,
                      changeManyAttrValue: _vm.changeManyAttrValue,
                    },
                    model: {
                      value: _vm.formValidate,
                      callback: function ($$v) {
                        _vm.formValidate = $$v
                      },
                      expression: "formValidate",
                    },
                  })
                : _vm._e(),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "3" && !_vm.isDisabled,
                      expression: "currentTab === '3' && !isDisabled",
                    },
                  ],
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品详情：" } },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isDisabled,
                                expression: "isDisabled",
                              },
                            ],
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.formValidate.content || "无"
                              ),
                            },
                          }),
                          _c("Tinymce", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isDisabled,
                                expression: "!isDisabled",
                              },
                            ],
                            key: _vm.htmlKey,
                            model: {
                              value: _vm.formValidate.content,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "content",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "4",
                      expression: "currentTab === '4'",
                    },
                  ],
                },
                [
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "初始评论数量：",
                            prop: "replyInfo.commentsNum",
                          },
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 0,
                              max: 999,
                              step: 1,
                              "step-strictly": "",
                            },
                            model: {
                              value: _vm.formValidate.replyInfo.commentsNum,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate.replyInfo,
                                  "commentsNum",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.replyInfo.commentsNum",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商品好评率：",
                            prop: "replyInfo.ratingRate",
                          },
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 90,
                              max: 100,
                              step: 0.01,
                              "step-strictly": "",
                            },
                            model: {
                              value: _vm.formValidate.replyInfo.ratingRate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate.replyInfo,
                                  "ratingRate",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.replyInfo.ratingRate",
                            },
                          }),
                          _vm._v(" % "),
                        ],
                        1
                      ),
                      _c("el-form-item", { attrs: { label: "虚拟评论：" } }, [
                        _c(
                          "div",
                          { staticClass: "flex" },
                          [
                            _c(
                              "el-button",
                              { on: { click: _vm.handleAddReplyItem } },
                              [_vm._v("添加虚拟评论")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-form-item", { attrs: { label: "" } }, [
                        _c(
                          "div",
                          [
                            _c(
                              "el-table",
                              {
                                key: "reply-list",
                                staticClass: "tabNumWidth",
                                attrs: {
                                  data: _vm.formValidate.replyInfo.replyList,
                                  border: "",
                                  size: "small",
                                },
                              },
                              [
                                _vm._l(_vm.replyHeader, function (item, index) {
                                  return _c("el-table-column", {
                                    key: index,
                                    attrs: {
                                      label: item.title,
                                      align: "center",
                                      "min-width": item.minWidth || "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              item.slot === "nickname"
                                                ? [
                                                    _c("el-input", {
                                                      attrs: {
                                                        maxlength: "10",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.formValidate
                                                            .replyInfo
                                                            .replyList[
                                                            scope.$index
                                                          ].nickname,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formValidate
                                                              .replyInfo
                                                              .replyList[
                                                              scope.$index
                                                            ],
                                                            "nickname",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formValidate.replyInfo.replyList[scope.$index].nickname",
                                                      },
                                                    }),
                                                  ]
                                                : item.slot === "avatar"
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "upLoadPicBox",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.modalPicTap(
                                                              false,
                                                              "replyAvatar",
                                                              scope.$index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        scope.row.avatar
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "upLoad tabPic",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: scope
                                                                      .row
                                                                      .avatar,
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "upLoad tabPic",
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-camera cameraIconfont",
                                                                  staticStyle: {
                                                                    "font-size":
                                                                      "24px",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                      ]
                                                    ),
                                                  ]
                                                : item.slot === "comment"
                                                ? [
                                                    _c("el-input", {
                                                      attrs: {
                                                        maxlength: "512",
                                                        type: "textarea",
                                                        autosize: {
                                                          minRows: 1,
                                                          maxRows: 2,
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.formValidate
                                                            .replyInfo
                                                            .replyList[
                                                            scope.$index
                                                          ].comment,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formValidate
                                                              .replyInfo
                                                              .replyList[
                                                              scope.$index
                                                            ],
                                                            "comment",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formValidate.replyInfo.replyList[scope.$index].comment",
                                                      },
                                                    }),
                                                  ]
                                                : item.slot === "replyDate"
                                                ? [
                                                    _c("el-date-picker", {
                                                      staticClass:
                                                        "selWidth100",
                                                      attrs: {
                                                        type: "date",
                                                        placeholder: "选择日期",
                                                        "value-format":
                                                          "yyyy-MM-dd",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.formValidate
                                                            .replyInfo
                                                            .replyList[
                                                            scope.$index
                                                          ].replyDate,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formValidate
                                                              .replyInfo
                                                              .replyList[
                                                              scope.$index
                                                            ],
                                                            "replyDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formValidate.replyInfo.replyList[scope.$index].replyDate",
                                                      },
                                                    }),
                                                  ]
                                                : item.slot === "star"
                                                ? [
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        min: 1,
                                                        max: 5,
                                                        "step-strictly": "",
                                                        "controls-position":
                                                          "right",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.formValidate
                                                            .replyInfo
                                                            .replyList[
                                                            scope.$index
                                                          ].star,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formValidate
                                                              .replyInfo
                                                              .replyList[
                                                              scope.$index
                                                            ],
                                                            "star",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formValidate.replyInfo.replyList[scope.$index].star",
                                                      },
                                                    }),
                                                  ]
                                                : item.slot === "pics"
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "acea-row row-center",
                                                      },
                                                      [
                                                        _vm._l(
                                                          scope.row.pics || [],
                                                          function (val, idx) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: idx,
                                                                staticClass:
                                                                  "pictrue",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: val,
                                                                  },
                                                                }),
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-error btndel",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleReplyPicRemove(
                                                                          scope.$index,
                                                                          idx
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        !scope.row.pics ||
                                                        scope.row.pics.length <
                                                          2
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "upLoadPicBox",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.modalPicTap(
                                                                        true,
                                                                        "replyPic",
                                                                        scope.$index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "upLoad",
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "el-icon-camera cameraIconfont",
                                                                    }),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                }),
                                _c("el-table-column", {
                                  key: "operation",
                                  attrs: {
                                    label: "操作",
                                    align: "center",
                                    "min-width": "100",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleReplyRemove(
                                                    scope.$index
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  Number(_vm.currentTab) > 1
                    ? _c(
                        "el-button",
                        {
                          staticClass: "submission priamry_border",
                          on: { click: _vm.handleSubmitUp },
                        },
                        [_vm._v("上一步")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: Number(_vm.currentTab) < 4,
                          expression: "Number(currentTab) < 4",
                        },
                      ],
                      staticClass: "priamry_border",
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmitNest("formValidate")
                        },
                      },
                    },
                    [_vm._v("下一步")]
                  ),
                  _vm.checkPermi([
                    "platform:integral:product:save",
                    "platform:integral:product:update",
                  ])
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.currentTab === "4" ||
                                  _vm.$route.params.id) &&
                                !_vm.isDisabled,
                              expression:
                                "(currentTab === '4' || $route.params.id) && !isDisabled",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary", loading: _vm.loadingBtn },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmit("formValidate")
                            },
                          },
                        },
                        [_vm._v("保存")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }